module.exports = __webpack_public_path__ + "img/8002.105fd8d4.gif";